import script from "./MarkdownEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkdownEditor.vue?vue&type=script&setup=true&lang=ts"

import "./css/markdown-editor.less?vue&type=style&index=0&id=0bce0a40&scoped=true&lang=less&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bce0a40"]])

export default __exports__